import React from "react";
import {reisy, use} from "reisy";

export const styles = reisy`
@namespace TagList;
TagList {
	list-style: none;
	display: flex;
	margin: 0;
	padding: 0;
	align-items: center;
	font-family: kent-font-aside-override, kent-font-aside, sans-serif;
}
`;

const TagList = ({publishable, filter}) => (
	<ul {...use(styles.TagList)}>
		{publishable.tags.filter(filter || (() => true)).map((t, i) => (
			<li key={i}>{t.name}</li>
		))}
	</ul>
);
export default TagList;


// WEBPACK FOOTER //
// ./lib/components/taglist.js